import {createUseStyles} from 'react-jss';
import MediaQueries from '../../v2/style-helper/MediaQueries';
import Spacing from '../../v2/style-helper/Spacing';

export default createUseStyles({
  popOver: {
    top: 0,
    left: '100%',
    marginLeft: Spacing.half,
    visibility: props => (props.show ? 'visible' : 'hidden'),
    position: 'absolute',
    zIndex: 3,
    padding: 5,
  
    [MediaQueries.phone]: {
      display: 'none !important',
    },
  },
  inner: {
    overflow: 'hidden',
    padding: 3,
    width: 240,
    borderRadius: 6,
    background: '#666',
  },
  arrow: {
    position: 'absolute',
    width: 0,
    height: 0,
    top: '50%',
    left: 0,
    marginTop: -5,
    borderTop: '5px solid transparent',
    borderRight: '5px solid #666',
    borderBottom: '5px solid transparent',
  },
  contents: {
    padding: [5, 10],
    backgroundColor: '#666',
    color: '#fff',
    
    '& p, & ul, & ol': {
      marginBottom: 0,
    },
  },
});
